import { FormattedMessage } from 'components/shared/Intl';
import { StrikeMetadata } from 'models/forms/fields';
import { useIntl } from 'react-intl';

import { HeaderCell } from '../../HeaderCell';
import { StyledTableHeaderWithDate } from './Data.styles';
import { StyledInitialValuationDate } from './InitialValuationDate';
import { StrikeMode } from './StrikeMode';

interface Props {
  strikeMetadata: StrikeMetadata;
}
export function Header({ strikeMetadata: { showMode, showDate, showSpot } }: Props) {
  const { formatMessage } = useIntl();
  return (
    <>
      {showMode && (
        <HeaderCell className="px-0">
          <div className="d-flex flex-column">
            <label htmlFor="StrikeMode" className="fs-6 mb-0 mt-2 ps-2">
              {formatMessage({
                id: 'quote.underlyingsGrid.header.strike',
              })}
            </label>
            <StrikeMode />
          </div>
        </HeaderCell>
      )}
      {showSpot && (
        <HeaderCell>
          <FormattedMessage id="quote.underlyingsGrid.header.spot" />
        </HeaderCell>
      )}
      {showDate && (
        <StyledTableHeaderWithDate>
          <label htmlFor="InitialValuationDate" className="fs-6 mx-2 mb-1 text-nowrap">
            {formatMessage({
              id: 'quote.underlyingsGrid.header.valuation',
            })}
          </label>
          <StyledInitialValuationDate />
        </StyledTableHeaderWithDate>
      )}
    </>
  );
}
